import { v4 as uuid } from 'uuid';
import * as yup from 'yup';

import Types from '../../../../properties/Types';
import createShapeFromProperties from '../../../../properties/createShapeFromProperties';
import { ObjectTypeBase } from '../../../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../../../types/properties/Property';
import { TypeContextEnum } from '../../../../types/properties/TypeContextEnum';
import TimeAvailabilityWeekRule from './TimeAvailabilityWeekRule';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    get default(): any {
      return uuid();
    },
  },
  allGroupRoles: {
    type: 'Boolean',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  groupRole: {
    type: 'GroupRole',
    isArray: true,
  },
  weekTimeRules: {
    type: 'TimeAvailabilityWeekRule',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  isAvailableAnytime: {
    type: 'Boolean',
    default: false,
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class WeeklyAvailabilityType extends ObjectTypeBase {
  name = 'WeeklyAvailability';

  contexts = [TypeContextEnum.Properties];

  friendlyName = 'Availability for days of the week';

  get example(): any {
    return {
      _id: uuid(),
      allGroupRoles: true,
      groupRole: null,
      weekTimeRules: TimeAvailabilityWeekRule.default,
      isAvailableAnytime: true,
    };
  }

  get default(): any {
    return {
      _id: uuid(),
      allGroupRoles: true,
      groupRole: null,
      weekTimeRules: TimeAvailabilityWeekRule.default,
      isAvailableAnytime: true,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties)).nullable();
  }

  properties = properties;
}

const definition = new WeeklyAvailabilityType();

Types.addType(definition);
export default definition;
